export default {"src":"/_next/static/media/skipper-octopus.39567ba0.svg","height":87,"width":88};